'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _templateObject = _taggedTemplateLiteral(['\n      transition-duration: ', 'ms;\n    '], ['\n      transition-duration: ', 'ms;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: 0;\n\n      transition-duration: ', 'ms;\n\n      transform: translate(\n        -50%,\n        ', '\n      );\n    '], ['\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: 0;\n\n      transition-duration: ', 'ms;\n\n      transform: translate(\n        -50%,\n        ', '\n      );\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      margin: 44px 0 0 0;\n      padding: 24px 20px 12px;\n      height: auto;\n      line-height: 1.35;\n      background-color: ', ';\n      border-radius: ', ';\n      color: ', ';\n    '], ['\n      margin: 44px 0 0 0;\n      padding: 24px 20px 12px;\n      height: auto;\n      line-height: 1.35;\n      background-color: ', ';\n      border-radius: ', ';\n      color: ', ';\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      margin: 0;\n    '], ['\n      margin: 0;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      margin: 0;\n      padding: 0 20px 24px 20px;\n    '], ['\n      margin: 0;\n      padding: 0 20px 24px 20px;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      margin: 0;\n      padding-bottom: 24px;\n    '], ['\n      margin: 0;\n      padding-bottom: 24px;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      position: fixed;\n      top: 0;\n      right: 0;\n      left: 0;\n      display: flex;\n      justify-content: space-between;\n      height: 44px;\n      padding: 0;\n      background-color: ', ';\n      border-radius: ', ';\n    '], ['\n      position: fixed;\n      top: 0;\n      right: 0;\n      left: 0;\n      display: flex;\n      justify-content: space-between;\n      height: 44px;\n      padding: 0;\n      background-color: ', ';\n      border-radius: ', ';\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _a11yDialog = require('a11y-dialog'),
    _a11yDialog2 = _interopRequireDefault(_a11yDialog),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _classnames = require('classnames'),
    _classnames2 = _interopRequireDefault(_classnames),
    _lodash = require('lodash.throttle'),
    _lodash2 = _interopRequireDefault(_lodash),
    _reactMedia = require('react-media'),
    _reactMedia2 = _interopRequireDefault(_reactMedia),
    _Transition = require('react-transition-group/Transition'),
    _Transition2 = _interopRequireDefault(_Transition),
    _utils = require('../utils'),
    _DialogCloseButton = require('./DialogCloseButton'),
    _DialogCloseButton2 = _interopRequireDefault(_DialogCloseButton),
    _DialogFullScreenActionButton = require('./DialogFullScreenActionButton'),
    _DialogFullScreenActionButton2 = _interopRequireDefault(_DialogFullScreenActionButton),
    _Button = require('../Button'),
    _Button2 = _interopRequireDefault(_Button),
    _Form = require('../Form'),
    _Form2 = _interopRequireDefault(_Form),
    _withCommonProps = require('../withCommonProps'),
    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
    _themes = require('../themes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme),
    _styles = require('../styles'),
    _propTypes3 = require('../propTypes');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var transitionDurationSmallExpand = 150,
    transitionDurationSmallCollapse = 75,
    transitionDurationLargeExpand = 300,
    transitionDurationLargeCollapse = 350,
    Styled = {
  div: {},
  h2: {}
};
Styled.div.root = _styledComponents2.default.div.withConfig({
  displayName: 'Dialog__root'
})(['', ';position:fixed;z-index:', ';opacity:', ';font-family:', ';-webkit-font-smoothing:antialiased;&[aria-hidden=\'true\']{display:', ';}transition-property:opacity;transition-duration:', 'ms;transition-timing-function:cubic-bezier(0,0,0.2,1);', ';'], function (props) {
  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({
    direction: props.theme.vstui.i18n.direction
  });
}, (0, _themes.getStyle)('Dialog_zIndex'), function (props) {
  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? 1 : 0;
}, (0, _themes.getStyle)('Dialog_fontFamily'), function (props) {
  return 'exited' === props.sc.transitionState ? 'none' : 'block';
}, function (props) {
  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationSmallExpand : transitionDurationSmallCollapse;
}, function (props) {
  return props.sc.fullScreen && (0, _styles.css)(_templateObject, 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationLargeExpand : transitionDurationLargeCollapse);
}), Styled.div.backdrop = _styledComponents2.default.div.withConfig({
  displayName: 'Dialog__backdrop'
})(['position:fixed;top:0;right:0;bottom:0;left:0;z-index:-1;background-color:', ';'], (0, _themes.getStyle)('DialogBackdrop_backgroundColor')), Styled.div.backdrop.displayName = 'Styled_div_backdrop', Styled.div.dialog = _styledComponents2.default.div.withConfig({
  displayName: 'Dialog__dialog'
})(['position:fixed;top:50%;left:50%;width:', ';max-width:calc(100% - 40px);min-height:', ';max-height:calc(100% - 40px);background-color:', ';border-radius:', ';box-shadow:', ';transform:translate(-50%,-50%) scale( ', ' );transition-property:transform;transition-duration:', 'ms;transition-timing-function:cubic-bezier(0,0,0.2,1);', ';'], function (props) {
  return (0, _themes.getStyle)('Dialog_width_' + props.size);
}, function (props) {
  return 'calc(' + (props.sc.darkHeader ? '20px' : '0px') + ' + ' + props.sc.headerHeight + 'px + 22px + ' + props.sc.footerHeight + 'px)';
}, (0, _themes.getStyle)('Dialog_backgroundColor'), (0, _themes.getStyle)('Dialog_borderRadius'), (0, _themes.getStyle)('Dialog_boxShadow'), function (props) {
  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? 1 : 0.9;
}, function (props) {
  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationSmallExpand : transitionDurationSmallCollapse;
}, function (props) {
  return props.sc.fullScreen && (0, _styles.css)(_templateObject2, 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationLargeExpand : transitionDurationLargeCollapse, 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? '-50%' : '50%');
}), Styled.div.content = _styledComponents2.default.div.withConfig({
  displayName: 'Dialog__content'
})(['display:flex;flex-direction:column;']), Styled.DialogCloseButton = (0, _styledComponents2.default)(_DialogCloseButton2.default).withConfig({
  displayName: 'Dialog__DialogCloseButton'
})(['position:absolute;top:0;right:', ';left:', ';z-index:2;'], function (props) {
  return 'rtl' === props.theme.vstui.i18n.direction ? 'auto' : 0;
}, function (props) {
  return 'rtl' === props.theme.vstui.i18n.direction ? 0 : 'auto';
}), Styled.DialogCloseButton.displayName = 'Styled_DialogCloseButton', Styled.h2.DialogTitle = _styledComponents2.default.h2.withConfig({
  displayName: 'Dialog__DialogTitle'
})(['z-index:1;margin:0;padding:', ';background-color:', ';border-radius:', ';box-shadow:', ';color:', ';font-size:', ';font-weight:', ';line-height:1.35;transition-property:none;transition-duration:', ';transition-timing-function:', ';', ';', ';'], function (props) {
  return props.sc.darkHeader ? '13px 24px' : '24px 24px 12px 24px';
}, function (props) {
  return props.sc.darkHeader ? props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_backgroundColor_darkHeaderSecondary') : (0, _themes.getStyle)('DialogTitle_backgroundColor_darkHeaderPrimary') : (0, _themes.getStyle)('DialogTitle_backgroundColor');
}, (0, _themes.getStyle)('DialogTitle_borderRadius'), function (props) {
  return props.sc.canScrollUp ? (0, _themes.getStyle)('DialogTitle_boxShadow') : 'none';
}, function (props) {
  return props.sc.darkHeader ? props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_color_darkHeaderSecondary') : (0, _themes.getStyle)('DialogTitle_color_darkHeaderPrimary') : props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_color_secondary') : (0, _themes.getStyle)('DialogTitle_color_primary');
}, (0, _themes.getStyle)('DialogTitle_fontSize'), (0, _themes.getStyle)('DialogTitle_fontWeight'), function (props) {
  return props.theme.vstui.transition.duration.shortest;
}, function (props) {
  return props.theme.vstui.transition.easing.easeIn;
}, function (props) {
  return props.sc.fullScreen && (0, _styles.css)(_templateObject3, (0, _themes.getStyle)('DialogTitle_backgroundColor_fullScreen'), (0, _themes.getStyle)('DialogTitle_borderRadius_fullScreen'), props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_color_secondary_fullScreen') : (0, _themes.getStyle)('DialogTitle_color_primary_fullScreen'));
}, function (props) {
  return !props.sc.renderActions && !props.sc.fullScreen && (0, _styles.css)(_templateObject4);
}), Styled.div.DialogContent = _styledComponents2.default.div.withConfig({
  displayName: 'Dialog__DialogContent'
})(['box-sizing:border-box;flex:1 1 auto;min-height:', ';max-height:', ';margin:0 0 calc(56px + 24px) 0;padding:', ';overflow-y:auto;color:', ';font-size:', ';line-height:1.43;word-break:break-word;', ';', ';'], function (props) {
  return props.sc.darkHeader ? '42px' : '22px';
}, function (props) {
  return 'calc(100vh - (' + (props.sc.fullScreen ? '0px' : '40px') + ' + ' + props.sc.headerHeight + 'px + ' + (props.sc.renderActions || props.sc.fullScreen ? props.sc.footerHeight : 0) + 'px))';
}, function (props) {
  return props.sc.darkHeader ? '20px 24px 0' : '0 24px';
}, (0, _themes.getStyle)('DialogContent_color'), (0, _themes.getStyle)('DialogContent_fontSize'), function (props) {
  return props.sc.fullScreen && (0, _styles.css)(_templateObject5);
}, function (props) {
  return !props.sc.renderActions && (0, _styles.css)(_templateObject6);
}), Styled.div.dialogActions = _styledComponents2.default.div.withConfig({
  displayName: 'Dialog__dialogActions'
})(['position:absolute;right:0;bottom:0;left:0;display:flex;justify-content:flex-end;padding:24px;background-color:', ';border-radius:', ';box-shadow:', ';transition-property:none;transition-duration:', ';transition-timing-function:', ';', ';', ';'], (0, _themes.getStyle)('DialogActions_backgroundColor'), (0, _themes.getStyle)('DialogActions_borderRadius'), function (props) {
  return props.sc.canScrollDown ? (0, _themes.getStyle)('DialogActions_boxShadow') : 'none';
}, function (props) {
  return props.theme.vstui.transition.duration.shortest;
}, function (props) {
  return props.theme.vstui.transition.easing.easeIn;
}, function (props) {
  return props.sc.fullScreen && (0, _styles.css)(_templateObject7, props.sc.secondary ? (0, _themes.getStyle)('DialogActions_backgroundColor_secondary_fullScreen') : (0, _themes.getStyle)('DialogActions_backgroundColor_primary_fullScreen'), (0, _themes.getStyle)('DialogActions_borderRadius_fullScreen'));
}, function (props) {
  return !props.sc.renderActions && !props.sc.fullScreen && (0, _styles.css)(_templateObject8);
});

var Dialog = function (_Component) {
  function Dialog(props) {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

    return _this.generatedId = (0, _utils.generateUniqueId)('dialog'), _this.state = {
      canScrollDown: !1,
      canScrollUp: !1,
      id: props.id || _this.generatedId,
      headerHeight: 0,
      footerHeight: 0
    }, _this.handleActionsRef = _this.handleActionsRef.bind(_this), _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind(_this), _this.handleContentRef = _this.handleContentRef.bind(_this), _this.handleFormRef = _this.handleFormRef.bind(_this), _this.handleKeyDown = _this.handleKeyDown.bind(_this), _this.handleOverlayClick = _this.handleOverlayClick.bind(_this), _this.handleRef = _this.handleRef.bind(_this), _this.handleResize = _this.handleResize.bind(_this), _this.handleScroll = _this.handleScroll.bind(_this), _this.handleTitleRef = _this.handleTitleRef.bind(_this), _this.handleResizeThrottled = (0, _lodash2.default)(_this.handleResize, 100), _this;
  }

  return _inherits(Dialog, _Component), _createClass(Dialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.a11yDialog = this.a11yDialog || this.initDialog(), this.props.open && this.show(), window.addEventListener('resize', this.handleResizeThrottled);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.id || this.generatedId;
      id !== this.state.id && this.setState({
        id: id
      }), !1 === nextProps.open && !1 !== this.props.open && this.form && this.form.reset();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      prevProps.open !== this.props.open && (this.props.open ? this.show() : this.hide()), (prevProps.alert !== this.props.alert || prevProps.children !== this.props.children || prevProps.darkHeader !== this.props.darkHeader || prevProps.size !== this.props.size || prevProps.title !== this.props.title) && this.updateDimensionsState(), this.updateScrollState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown), this.content && this.content.removeEventListener('scroll', this.handleScroll), this.a11yDialog && this.a11yDialog.destroy(), this.moveNodeBack(), window.removeEventListener('resize', this.handleResizeThrottled);
    }
  }, {
    key: 'show',
    value: function show() {
      document.addEventListener('keydown', this.handleKeyDown), this.a11yDialog.show();
    }
  }, {
    key: 'hide',
    value: function hide() {
      document.removeEventListener('keydown', this.handleKeyDown), this.a11yDialog.hide(), this.props.onRequestClose();
    }
  }, {
    key: 'moveNodeBack',
    value: function moveNodeBack() {
      this.mainContainer && (this.mainContainer.parentNode.removeChild(this.node), this.ancestor.appendChild(this.node));
    }
  }, {
    key: 'moveNode',
    value: function moveNode() {
      this.mainContainer && (this.ancestor.removeChild(this.node), this.mainContainer.parentNode.appendChild(this.node));
    }
  }, {
    key: 'initDialog',
    value: function initDialog() {
      return this.mainContainer = document.querySelector(this.props.rootSelector), this.ancestor = this.node.parentNode, this.moveNode(), new _a11yDialog2.default(this.node, this.mainContainer);
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      this.updateDimensionsState();
    }
  }, {
    key: 'updateDimensionsState',
    value: function updateDimensionsState() {
      var headerHeight = this.title ? this.title.offsetHeight : 0,
          footerHeight = this.actions ? this.actions.offsetHeight : 0;
      this.setState({
        headerHeight: headerHeight,
        footerHeight: footerHeight
      });
    }
  }, {
    key: 'handleActionsRef',
    value: function handleActionsRef(node) {
      this.actions = node, this.actions && this.updateDimensionsState();
    }
  }, {
    key: 'handleTitleRef',
    value: function handleTitleRef(node) {
      this.title = node, this.title && this.updateDimensionsState();
    }
  }, {
    key: 'handleContentRef',
    value: function handleContentRef(node) {
      this.content = node, this.content && (this.content.addEventListener('scroll', this.handleScroll), this.updateScrollState());
    }
  }, {
    key: 'handleFormRef',
    value: function handleFormRef(node) {
      this.form = node;
      var formProps = this.props.formProps;
      formProps && formProps.innerRef && formProps.innerRef(node);
    }
  }, {
    key: 'handleRef',
    value: function handleRef(node) {
      this.node = node;
    }
  }, {
    key: 'handleOverlayClick',
    value: function handleOverlayClick(event) {
      this.props.requireInteraction || this.props.onRequestClose(event);
    }
  }, {
    key: 'handleCloseButtonClick',
    value: function handleCloseButtonClick(event) {
      this.props.onRequestClose(event);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      event.which === 27 && (event.stopImmediatePropagation(), !this.props.requireInteraction && this.props.onRequestClose(event));
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      this.updateScrollState();
    }
  }, {
    key: 'updateScrollState',
    value: function updateScrollState() {
      var _state = this.state,
          canScrollDown = _state.canScrollDown,
          canScrollUp = _state.canScrollUp,
          _content = this.content,
          clientHeight = _content.clientHeight,
          scrollHeight = _content.scrollHeight,
          scrollTop = _content.scrollTop;
      !canScrollUp && 0 < scrollTop ? this.setState({
        canScrollUp: !0
      }) : canScrollUp && 0 === scrollTop && this.setState({
        canScrollUp: !1
      }), !canScrollDown && scrollTop + clientHeight < scrollHeight ? this.setState({
        canScrollDown: !0
      }) : canScrollDown && scrollTop + clientHeight === scrollHeight && this.setState({
        canScrollDown: !1
      });
    }
  }, {
    key: 'renderDialogActions',
    value: function renderDialogActions(theme, fullScreen, closeButtonLabel) {
      var _props = this.props,
          primaryActionButtonProp = _props.primaryActionButton,
          secondary = _props.secondary,
          secondaryActionButtonProp = _props.secondaryActionButton,
          requireInteraction = _props.requireInteraction,
          canScrollDown = this.state.canScrollDown,
          primaryActionButton = primaryActionButtonProp ? _react2.default.createElement(_Button2.default, {
        inheritStyles: !0,
        key: primaryActionButtonProp.label,
        onClick: primaryActionButtonProp.onClick,
        secondary: secondary,
        theme: theme
      }, primaryActionButtonProp.label) : null,
          secondaryActionButton = secondaryActionButtonProp ? _react2.default.createElement(_Button2.default, {
        color: 'neutral',
        inheritStyles: !0,
        key: secondaryActionButtonProp.label,
        naked: !0,
        onClick: secondaryActionButtonProp.onClick,
        secondary: secondary,
        theme: theme,
        type: 'button'
      }, secondaryActionButtonProp.label) : null,
          primaryFullScreenActionButton = primaryActionButtonProp ? _react2.default.createElement(_DialogFullScreenActionButton2.default, {
        inheritStyles: !0,
        key: primaryActionButtonProp.label,
        onClick: primaryActionButtonProp.onClick,
        secondary: secondary,
        theme: theme,
        variant: 'primary'
      }, primaryActionButtonProp.label) : fullScreen && !requireInteraction ? _react2.default.createElement(_DialogFullScreenActionButton2.default, {
        key: closeButtonLabel,
        onClick: this.handleCloseButtonClick,
        secondary: secondary,
        theme: theme,
        variant: 'primary'
      }, closeButtonLabel) : null,
          secondaryFullScreenActionButton = secondaryActionButtonProp ? _react2.default.createElement(_DialogFullScreenActionButton2.default, {
        inheritStyles: !0,
        key: secondaryActionButtonProp.label,
        onClick: secondaryActionButtonProp.onClick,
        secondary: secondary,
        theme: theme,
        type: 'button',
        variant: 'secondary'
      }, secondaryActionButtonProp.label) : null;
      return _react2.default.createElement(Styled.div.dialogActions, {
        innerRef: this.handleActionsRef,
        sc: {
          canScrollDown: canScrollDown,
          fullScreen: fullScreen,
          renderActions: primaryActionButton || secondaryActionButton,
          secondary: secondary
        },
        theme: theme
      }, fullScreen ? secondaryFullScreenActionButton : secondaryActionButton, fullScreen ? primaryFullScreenActionButton : primaryActionButton);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _props2 = this.props,
          alert = _props2.alert,
          ariaDescribedBy = _props2['aria-describedby'],
          children = _props2.children,
          classes = _props2.classes,
          className = _props2.className,
          closeButtonLabelProp = _props2.closeButtonLabel,
          commonProps = _props2.commonProps,
          darkHeader = _props2.darkHeader,
          formProps = _props2.formProps,
          idIgnored = _props2.id,
          inheritStyles = _props2.inheritStyles,
          open = _props2.open,
          requireInteraction = _props2.requireInteraction,
          secondary = _props2.secondary,
          size = _props2.size,
          themeProp = _props2.theme,
          title = _props2.title,
          primaryActionButton = _props2.primaryActionButton,
          secondaryActionButton = _props2.secondaryActionButton,
          _state2 = this.state,
          footerHeight = _state2.footerHeight,
          headerHeight = _state2.headerHeight,
          id = _state2.id,
          theme = (0, _componentTheme2.default)(themeProp),
          i18n = theme.vstui.i18n,
          closeButtonLabel = closeButtonLabelProp || i18n.t('dialog.closeButton'),
          canScrollUp = this.state.canScrollUp,
          titleId = id + '-title';

      return _react2.default.createElement(_reactMedia2.default, {
        query: theme.vstui.Dialog_breakpoint_xs
      }, function (matches) {
        var fullScreen = matches && !alert,
            renderActions = primaryActionButton || secondaryActionButton;
        return _react2.default.createElement(_Transition2.default, {
          in: open,
          timeout: {
            enter: fullScreen ? transitionDurationLargeExpand : transitionDurationSmallExpand,
            exit: fullScreen ? transitionDurationLargeCollapse : transitionDurationSmallCollapse
          }
        }, function (transitionState) {
          return _react2.default.createElement(Styled.div.root, _extends({}, commonProps, {
            "aria-hidden": !open,
            className: (0, _classnames2.default)(className, classes.root),
            id: id,
            innerRef: _this2.handleRef,
            sc: {
              fullScreen: fullScreen,
              inheritStyles: inheritStyles,
              transitionState: transitionState
            },
            theme: theme
          }), _react2.default.createElement(Styled.div.backdrop, {
            className: classes.backdrop,
            onClick: _this2.handleOverlayClick,
            tabIndex: -1,
            theme: theme
          }), _react2.default.createElement(Styled.div.dialog, {
            "aria-describedby": ariaDescribedBy,
            "aria-labelledby": titleId,
            className: classes.dialog,
            role: 'dialog',
            sc: {
              darkHeader: darkHeader,
              footerHeight: footerHeight,
              fullScreen: fullScreen,
              headerHeight: headerHeight,
              transitionState: transitionState
            },
            size: size,
            theme: theme
          }, _react2.default.createElement(Styled.div.content, {
            className: classes.content,
            role: 'document'
          }, !requireInteraction && !fullScreen && _react2.default.createElement(Styled.DialogCloseButton, {
            className: classes.closeButton,
            color: darkHeader ? 'white' : 'neutral',
            inheritStyles: !0,
            label: closeButtonLabel,
            onClick: _this2.handleCloseButtonClick,
            theme: theme
          }), _react2.default.createElement(Styled.h2.DialogTitle, {
            id: titleId,
            innerRef: _this2.handleTitleRef,
            sc: {
              darkHeader: darkHeader,
              fullScreen: fullScreen,
              canScrollUp: canScrollUp,
              secondary: secondary,
              renderActions: renderActions
            },
            theme: theme
          }, title), _react2.default.createElement(Styled.div.DialogContent, {
            innerRef: _this2.handleContentRef,
            sc: {
              darkHeader: darkHeader,
              fullScreen: fullScreen,
              headerHeight: headerHeight,
              footerHeight: footerHeight,
              renderActions: renderActions
            },
            theme: theme
          }, formProps && _react2.default.createElement(_Form2.default, _extends({}, formProps, {
            inheritStyles: !0,
            onRef: _this2.handleFormRef
          }), children, _this2.renderDialogActions(theme, fullScreen, closeButtonLabel)), !formProps && children), !formProps && _this2.renderDialogActions(theme, fullScreen, closeButtonLabel))));
        });
      });
    }
  }]), Dialog;
}(_react.Component);

Dialog.propTypes = {
  "aria-describedby": _propTypes2.default.string,
  primaryActionButton: _propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func
  }),
  secondaryActionButton: _propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func
  }),
  formProps: _propTypes2.default.shape({
    action: _propTypes2.default.string,
    innerRef: _propTypes2.default.func,
    method: _propTypes2.default.oneOf(['get', 'post']),
    onSubmit: _propTypes2.default.func,
    onValidate: _propTypes2.default.func
  }),
  alert: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  classes: _propTypes2.default.objectOf(_propTypes2.default.string),
  className: _propTypes2.default.string,
  closeButtonLabel: _propTypes2.default.string,
  commonProps: _propTypes3.commonPropsShape,
  darkHeader: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  inheritStyles: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  requireInteraction: _propTypes2.default.bool,
  rootSelector: _propTypes2.default.string,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes3.themeShape,
  title: _propTypes2.default.string.isRequired
}, Dialog.defaultProps = {
  rootSelector: '#root',
  classes: {
    root: '',
    backdrop: '',
    dialog: '',
    content: '',
    closeButton: ''
  },
  size: 'small',
  theme: (0, _themes.createTheme)()
}, Dialog.displayName = 'Dialog';
var DialogWithTheme = (0, _withCommonProps2.default)(Dialog);
DialogWithTheme.WrappedComponent = Dialog, exports.default = DialogWithTheme;